import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GOOGLE_MAPS_QUERY_FEATURE_SERVICE, GoogleMapsWidgetModule } from '@sbb-amsgis/google-maps';
import { ENVIRONMENT } from '../../../../environments/environment';
import { GoogleMapsToolComponent } from './components/google-maps-tool/google-maps-tool.component';
import { SharedModule } from '../../../shared/shared.module';
import { DragDropModule } from '../../../core/drag-drop/drag-drop.module';
import { GoogleMapConfigModule } from '../../../../assets/config/shared/google-map.config';
import { GoogleMapsToolService } from './services/google-maps-tool.service';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [GoogleMapsToolComponent],
  imports: [
    CommonModule,
    SharedModule,
    DragDropModule,
    GoogleMapConfigModule,
    TranslateModule,
    GoogleMapsWidgetModule.forRoot(ENVIRONMENT.googleMapsConfig),
  ],
  providers: [
    {
      provide: GOOGLE_MAPS_QUERY_FEATURE_SERVICE,
      useClass: GoogleMapsToolService,
    },
  ],
})
export class GoogleMapsToolModule {}
